import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/app.config';
import { Store } from '@ngxs/store';
import { OptionsState } from 'src/app/store-ngxs/states/options.state';
import {
  SetActiveTheme,
  SetTheme,
} from 'src/app/store-ngxs/actions/options.actions';

@Component({
  selector: 'app-customizer',
  standalone: true,
  imports: [TablerIconsModule, MaterialModule, FormsModule, NgScrollbarModule],
  templateUrl: './customizer.component.html',
  styleUrls: ['./customizer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomizerComponent {
  @Output() optionsChange = new EventEmitter<AppSettings>();
  hideSingleSelectionIndicator = signal(true);
  optionsState: OptionsState;

  constructor(private settings: CoreService, private store: Store) {
    this.store.select(OptionsState.options).subscribe((options) => {
      this.options = { ...this.options, ...options };
    });
  }
  options = this.settings.getOptions();

  setDark() {
    this.optionsChange.emit(this.options);
    this.store.dispatch(new SetTheme(this.options.theme));
  }

  setColor() {
    this.optionsChange.emit(this.options);
    this.store.dispatch(new SetActiveTheme(this.options.activeTheme));
  }
}
